import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import TextInput from '../../../../../Form/TextInput';
import SidePopup from '../../../SidePopup';

import useSwitchableData from '../../../../../../hooks/useSwitchableData';
import { UiContext } from '../../../../../../context/UiContext';
import AdminService from '../../../../../../services/AdminService';
import classes from './styles.module.scss';

export default function ViewInterviewer({
  isVisible,
  handleClose,
  interviewers,
  currentInterviewerId,
  refetch,
  setIsEditInterviewerVisible,
  setSelectedRows,
  isOverlayed,
}) {
  const { showModal, showUnknownErrorModal, setIsFetching } =
    useContext(UiContext);

  const { t } = useTranslation();

  const { currentDataIndex, switchToPrevDataElement, switchToNextDataElement } =
    useSwitchableData(interviewers, currentInterviewerId);

  const deleteInterviewer = () => {
    showModal({
      icon: 'delete',
      title: t(
        'dashboardComponents.Console.ExternalInterviewers.ViewInterviewer.deleteConfirmation.title'
      ),
      text: t(
        'dashboardComponents.Console.ExternalInterviewers.ViewInterviewer.deleteConfirmation.text'
      ),
      onConfirm: async () => {
        try {
          setIsFetching(true);
          await AdminService.deleteExternalInterviewer({
            id: interviewers?.[currentDataIndex].id,
          });

          await refetch();
          handleClose();
        } catch (error) {
          console.log(error);
          showUnknownErrorModal();
        } finally {
          setIsFetching(false);
        }
      },
      onCancel: () => {},
      dismissButtonLabel: 'No',
      confirmButtonLabel: 'Yes',
    });
  };

  const editInterviewer = () => {
    setSelectedRows([interviewers[currentDataIndex]?.id]);
    setIsEditInterviewerVisible(true);
  };

  return (
    <SidePopup
      isVisible={isVisible}
      handleClose={handleClose}
      title={t(
        'dashboardComponents.Console.ExternalInterviewers.ViewInterviewer.title'
      )}
      isOverlayed={isOverlayed}
      onLeftButtonClick={deleteInterviewer}
      mode="view"
      onRightButtonClick={editInterviewer}
      switchNext={interviewers?.length > 1 && switchToNextDataElement}
      switchPrev={interviewers?.length > 1 && switchToPrevDataElement}
    >
      <div className={classes.ViewInterviewer}>
        <div className={classes.colsContainer}>
          <div className={classes.col}>
            <TextInput
              label={t(
                'dashboardComponents.Console.ExternalInterviewers.ViewInterviewer.labels.firstName'
              )}
              readonly
              height={50}
              value={interviewers?.[currentDataIndex]?.firstName}
            />
            <TextInput
              label={t(
                'dashboardComponents.Console.ExternalInterviewers.ViewInterviewer.labels.designation'
              )}
              readonly
              height={50}
              value={interviewers?.[currentDataIndex]?.designation}
            />
            <TextInput
              label={t(
                'dashboardComponents.Console.ExternalInterviewers.ViewInterviewer.labels.phone'
              )}
              readonly
              height={50}
              value={interviewers?.[currentDataIndex]?.phone}
            />
          </div>
          <div className={classes.col}>
            <TextInput
              label={t(
                'dashboardComponents.Console.ExternalInterviewers.ViewInterviewer.labels.lastName'
              )}
              readonly
              height={50}
              value={interviewers?.[currentDataIndex]?.lastName}
            />
            <TextInput
              label={t(
                'dashboardComponents.Console.ExternalInterviewers.ViewInterviewer.labels.email'
              )}
              readonly
              height={50}
              value={interviewers?.[currentDataIndex]?.email}
            />
          </div>
        </div>
      </div>
    </SidePopup>
  );
}
